import React from 'react';
import styles from './proportion-bar.module.css';

const ProportionBar = ({ value1, value2, color1, color2 }) => {
  const total = value1 + value2;
  const percent1 = (value1 / total) * 100;
  const percent2 = (value2 / total) * 100;

  return (
    <div className={styles.container}>
      <div
        className={styles.section}
        style={{ width: `${percent1}%`, backgroundColor: color1 }}
      ></div>
      <div
        className={styles.section}
        style={{ width: `${percent2}%`, backgroundColor: color2 }}
      ></div>
    </div>
  );
};

export default ProportionBar;